import React from "react";
import { animated, useSpring } from "@react-spring/web";

export const Fade = ({ isVisible, children, style }) => {
  const { x } = useSpring({
    from: { x: 0 }, // Starting value of the animated property
    x: isVisible ? 1 : 0, // Ending value of the animated property based on the state
    config: { duration: 600 }, // Configuration for the animation, specifying the duration
  });
  const styles = { ...style, opacity: x.to({ range: [0, 1], output: [0, 1] }) };

  return <animated.div style={styles}>{children}</animated.div>;
};
